import { useEffect } from "react";
import { findFirstVisibleChild } from "../../utils/findFirstVisibleChild";
import { fromHtml } from "../../utils/fromHtml";
import useLinesCache from "./useLinesCache";

export function useScrollingEffect(
	setID,
	plasmidID,
	scrollRef,
	overviewRef,
	baseRef,
	containerInfo,
	scrollInfo,
	lineHeightData,
) {
	const getLineHtml = useLinesCache();
	useEffect(() => {
		if (
			lineHeightData == null ||
			containerInfo == null ||
			scrollRef.current == null ||
			overviewRef.current == null
		) {
			return;
		}
		const overview = overviewRef.current;
		const { estLineHeight, length, lineCount } = lineHeightData;
		const { clientHeight, scrollTop } = scrollRef.current;

		const linesOnPage = Math.round(
			Math.floor(clientHeight / estLineHeight) + 1,
		);
		const firstVisibleChild = findFirstVisibleChild(overview, scrollTop);

		if (firstVisibleChild == null) return;

		const firstVisibleLineNo = +firstVisibleChild.dataset.lineNo;

		baseRef.current = firstVisibleLineNo * length;

		const start = Math.max(0, firstVisibleLineNo - linesOnPage);
		const end = Math.min(lineCount - 1, firstVisibleLineNo + 2 * linesOnPage);

		Array.from({ length: end - start + 1 }).forEach((_, index) => {
			const lineNo = start + index;
			const linePlaceholder = document.getElementById(
				`line-placeholder-${lineNo}`,
			);
			if (linePlaceholder == null || linePlaceholder.loading) return;
			linePlaceholder.loading = true;

			getLineHtml(setID, plasmidID, length, lineNo).then((html) => {
				if (linePlaceholder && overview.contains(linePlaceholder) && html) {
					const line = fromHtml(html);

					line.dataset.lineNo = lineNo;

					overview.replaceChild(line, linePlaceholder);
				}
			});
		});
	}, [lineHeightData, containerInfo?.clientWidth, scrollInfo?.scrollTop]);
}
